import http from 'hub-http/clients/apiClient';
import { useEffect, useState } from 'react';
import { FetchStatuses } from '../../common/types/FetchStatus';
const MARKETING_EVENT_TYPE_ID = '0-54';
const MARKETING_EVENT_ATTENDANCE_TYPE_ID = '0-147';
export const shouldLinkToAssociation = objectTypeId => {
  return MARKETING_EVENT_ATTENDANCE_TYPE_ID === objectTypeId;
};
const LOADING_STATE = {
  status: FetchStatuses.LOADING,
  data: null
};
export const fetchAssociatedObjectsRecord = async ({
  objectTypeId,
  objectId
}) => {
  if (!shouldLinkToAssociation(objectTypeId)) {
    throw new Error(`objectTypeId=${objectId} is not supported for useAssociatedObjectsRecord hook.`);
  }
  const rawResult = await http.get(`associations/v1/associations/${MARKETING_EVENT_ATTENDANCE_TYPE_ID}/${objectId}/associations-to/${MARKETING_EVENT_TYPE_ID}`);
  const results = rawResult.results;
  const association = results[results.length - 1];
  return {
    objectTypeId: MARKETING_EVENT_TYPE_ID,
    objectId: association.objectId
  };
};
export const useAssociatedObjectsRecord = (objectTypeId, objectId) => {
  const [associationRecord, setAssociationRecord] = useState(LOADING_STATE);
  useEffect(() => {
    setAssociationRecord({
      status: FetchStatuses.LOADING,
      data: null
    });
    fetchAssociatedObjectsRecord({
      objectTypeId,
      objectId
    }).then(result => {
      setAssociationRecord({
        status: FetchStatuses.RESOLVED,
        data: result
      });
    }).catch(e => {
      setAssociationRecord({
        status: FetchStatuses.REJECTED,
        data: null,
        error: e
      });
    });
  }, [objectId, objectTypeId]);
  return associationRecord;
};